export default __webpack_public_path__ + "static/media/scarringActive.419bd3c0.svg";